import Client, { LeadStage } from '@spike/client-model';
import moment, { Moment } from 'moment-timezone';

export const EMPTY_METRIC = '—';

export interface LeadDateTime {
    date: string;
    time: string;
}

export const formatLeadDateTime = (value: Moment, timeZone: string): LeadDateTime => {
    const zoned = value.clone().tz(timeZone);
    return { date: zoned.format('MMM D, YYYY'), time: zoned.format('h:mma') };
};

/** Days elapsed since creation; once converted, the date the lead became a client. */
export const buildLeadAge = (lead: Client, timeZone: string): string => {
    if (lead.leadStage === LeadStage.Won && lead.clientSince) {
        return lead.clientSince.clone().tz(timeZone).format('MM/DD/YYYY');
    }
    if (!lead.createdAt) {
        return EMPTY_METRIC;
    }
    const days = moment().diff(lead.createdAt, 'days');
    return days === 1 ? '1 Day' : `${days} Days`;
};

export interface LeadDateMetric {
    label: string;
    value: LeadDateTime | undefined;
}

export const buildLeadDateMetrics = (lead: Client, timeZone: string): Array<LeadDateMetric> => {
    const format = (value: Moment | null | undefined): LeadDateTime | undefined =>
        value ? formatLeadDateTime(value, timeZone) : undefined;

    return [
        { label: 'Created', value: format(lead.createdAt) },
        { label: 'First Contact', value: format(lead.firstContactDate) },
        { label: 'Last Contacted', value: format(lead.lastContactedAt) },
        { label: 'First Booked', value: format(lead.firstBookedDate) }
    ];
};
